const getNextPosition = (data) => {
    if (data.length === 0) return 1;
    return Math.max(...data?.map(item => item.position)) + 1;
};
  const getVimeoEmbedUrl = (url) => {
    if (!url) return "";
    const match = url.match(/vimeo\.com\/(\d+)/);
    return match ? `https://player.vimeo.com/video/${match[1]}?autoplay=1&muted=1&loop=1&background=1` : "";
  };
  
export {getNextPosition,getVimeoEmbedUrl}